import * as React from 'react';
import clsx from 'clsx';
import styles from './switch.module.css';

export interface SwitchProps {
    checked: boolean;
    onChange: (checked: boolean) => void;
    label?: React.ReactNode;
    disabled?: boolean;
    testId?: string;
    'aria-label'?: string;
    id?: string;
    className?: string;
}

export const Switch: React.FC<SwitchProps> = (props) => {
    const { checked, onChange, label, disabled = false, testId, id, className } = props;

    const button = (
        <button
            type="button"
            role="switch"
            id={id}
            className={styles['track']}
            aria-checked={checked}
            aria-label={props['aria-label']}
            disabled={disabled}
            data-testid={testId}
            onClick={() => onChange(!checked)}
        />
    );

    if (label === undefined) {
        return button;
    }

    // A label wrapping the button names it and makes the text clickable
    return (
        <label htmlFor={id} className={clsx(styles['root'], className)}>
            {button}
            {label}
        </label>
    );
};
